
import Vue from 'vue';
import { ContentModel } from '@descomplica/dex-models';
import TextArticle from '../article/TextArticle.vue';
import ImageArticle from '../article/ImageArticle.vue';

const contentComponents: { [name: string]: Vue.Component } = {
  text: TextArticle,
  image: ImageArticle,
};

export default Vue.extend({
  components: {
    TextArticle,
    ImageArticle,
  },
  props: {
    content: {
      type: Object as Vue.PropType<ContentModel>,
      required: true,
    },
    trustedContent: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    behavior(): string {
      return this.content.behavior || '';
    },
    contentComponent(): Vue.Component | undefined {
      return contentComponents[this.behavior];
    },
  },
});
